<template>
  <v-row class="pa-4" wrap>
    <v-col cols="12">
      <p class="subheading">
        {{ $tc('HSMrestoreMassage') }}
      </p>
    </v-col>

    <v-col cols="12">
      <v-text-field
        id="Input_pwd_restore"
        :label="$tc('password_file')"
        :hint="$tc('password_backup_hint')"
        type="password"
        v-model="password"
        counter
        required
        :error-messages="passwordErrors"
        @input="$v.password.$touch()"
        @blur="$v.password.$touch()"
      />
    </v-col>

    <v-col cols="12">
      <v-switch id="Switch_restore_network" color="green" :label="$tc('restore_network')" v-model="restoreNetwork" />
    </v-col>

    <template v-if="uploadProgress === null">
      <v-col cols="12">
        <div class="mb-3">
          <app-drag-and-drop ref="upload" @file="addFile" />
        </div>
      </v-col>

      <v-col cols="12">
        <v-btn
          id="Restore_btn"
          color="red"
          class="ma-0 mt-2"
          :disabled="$v.$invalid"
          :dark="!$v.$invalid"
          @click.prevent="restoreBackup"
        >
          {{ $t('upload') }}
        </v-btn>
      </v-col>
    </template>
    <template v-else>
      <v-col>
        <v-row class="mx-1">
          <v-progress-linear :value="uploadProgress" />
        </v-row>
        <v-row justify="end" class="mx-0 mb-4 mt-2">
          <v-btn
            id="abort"
            color="green"
            @click="abort"
          >
            {{ $tc('abort_uplaod') }}
          </v-btn>
        </v-row>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import AppDragAndDrop from '@/components/ui/AppDragAndDrop'
import { required, minLength } from 'vuelidate/lib/validators'
export default {
  data () {
    return {
      password: null,
      restoreNetwork: false,
      file: null
    }
  },
  validations () {
    return {
      password: {
        required,
        minLength: minLength(8)
      }
    }
  },
  components: {
    AppDragAndDrop
  },
  methods: {
    abort () {
      this.$store.dispatch('hsm/abortRestoreBackup').then(() => {
        this.clearForm()
      })
    },
    addFile (file) {
      this.file = file
    },
    restoreBackup () {
      const self = this
      this.$store
        .dispatch('hsm/restoreBackupHSM', {
          pwd: this.password,
          restore: this.restoreNetwork,
          file: this.file
        })
        .then(() => {
          this.$notify.success({})
          this.clearForm()
          self.$store.dispatch('warning/load')
        })
        .catch(err => {
          this.clearForm()
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
    },
    clearForm () {
      this.password = null
      this.restoreNetwork = false
      this.file = null
      this.$v.$reset()
    }
  },
  watch: {
    file (val) {
      // console.log(val)
    }
  },
  computed: {
    uploadProgress () {
      return this.$store.state.hsm.restoreBackupProgress
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.minLength &&
        errors.push(this.$t('$validation.min_length', { num: 8 }))
      !this.$v.password.required && errors.push(this.$t('$validation.required'))
      return errors
    }
  }
}
</script>
